import { PlayLayout } from '@app/play-now/routes/PlayLayout';
import { setupPlayUtils } from '@app/play-now/routes/remix-route-helper';
import { randomGif } from '@play-now/video/pages/Error/ErrorGif';
import { PageNotFound } from '@play-now/video/pages/Error/PageNotFound';
import { json, LoaderFunctionArgs } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';

export const loader = (args: LoaderFunctionArgs) => {
  const { config } = setupPlayUtils(args);
  return json({ gif: randomGif(config.businessUnit) }, { status: 404 });
};

const PageNotFoundRoute = () => {
  const { gif } = useLoaderData<typeof loader>();

  return (
    <PlayLayout pageId='pageNotFound'>
      <PageNotFound gif={gif} />
    </PlayLayout>
  );
};

export default PageNotFoundRoute;
